function pickLanguageContent(rows, locale, defaultLocale) {
    const list = Array.isArray(rows) ? rows.filter((r) => r && r.languageCode) : [];
    if (!list.length) return null;
    const short = (c) => String(c || "").split("-")[0];
    return list.find((r) => r.languageCode === locale) || list.find((r) => short(r.languageCode) === short(locale)) || list.find((r) => r.languageCode === defaultLocale) || list[0];
}
module.exports = { pickLanguageContent };



// WEBPACK FOOTER //
// ./src/utils/shell/pickLanguageContent.js